import NutritionalFactsTable from "../../../components/reusables/nutritionalFactsTable";

const ProductNutritionalInfoForm = ({ formik }) => {
    return (
        <div className="max-w-xl mx-auto">
            <NutritionalFactsTable
                value={formik.values.nutrition}
                onChange={(rows) => {
                    formik.setFieldValue('nutrition', rows);
                }}
            />
        </div>
    );
};

export default ProductNutritionalInfoForm;
